import React from "react";
import { Modal, Button, Alert } from "react-bootstrap";
import { useDeletePromotionalCode } from "../../hooks/useDeletePromotionalCode";

const PromotionalCodeDeleteModal = ({ show, onHide, code }) => {
  const { mutate: deleteCode, isPending: isDeleting } = useDeletePromotionalCode();

  const handleDelete = () => {
    if (!code?.id) return;
    deleteCode(code.id, {
      onSuccess: () => {
        onHide();
      },
    });
  };

  const usageCount = code?.usedCount || 0;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete Promotional Code</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="warning">
          Are you sure you want to delete the promotional code <strong>{code?.code}</strong>?
        </Alert>
        {usageCount > 0 && (
          <Alert variant="info" className="mt-3">
            This code has been used <strong>{usageCount}</strong> time(s). Deleting will set it to inactive status.
          </Alert>
        )}
        <p className="mb-0">This action cannot be undone. The code will be soft deleted (set to inactive).</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isDeleting}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleDelete} disabled={isDeleting}>
          {isDeleting ? "Deleting..." : "Delete Code"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PromotionalCodeDeleteModal;

